export const NOTICE_NUM_PER_PAGE = 10;
